import { Flex } from '@chakra-ui/react';
import {
  faCheck,
  faTriangleExclamation,
  faArrowsRotate,
  faCircleInfo,
  faBug,
  faClock
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ECheckLifecycleStatus,
  EResultStatus
} from '@publishing-engine/domain/models';

const colorsAndIcons = {
  FAIL: {
    backgroundColor: 'actionPrimaryCautionFill',
    color: 'neutralPrimaryFill',
    icon: faTriangleExclamation
  },
  FAILED: {
    backgroundColor: 'actionPrimaryCautionFill',
    color: 'neutralPrimaryFill',
    icon: faTriangleExclamation
  },
  RED: {
    backgroundColor: 'actionPrimaryCautionFill',
    color: 'neutralPrimaryFill',
    icon: faTriangleExclamation
  },
  SUCCESS: {
    backgroundColor: 'successPrimaryContentAccent',
    color: 'neutralPrimaryFill',
    icon: faCheck
  },
  GREEN: {
    backgroundColor: 'successPrimaryContentAccent',
    color: 'neutralPrimaryFill',
    icon: faCheck
  },
  COMPLETE: {
    backgroundColor: 'successPrimaryContentAccent',
    color: 'neutralPrimaryFill',
    icon: faCheck
  },
  PROCESSING: {
    backgroundColor: 'neutralSecondaryFill',
    color: 'actionSecondaryContent',
    icon: faArrowsRotate
  },
  NOT_STARTED: {
    backgroundColor: 'neutralSecondaryFill',
    color: 'actionSecondaryContent',
    icon: faArrowsRotate
  },
  WARNING: {
    backgroundColor: 'attentionPrimaryContentAccent',
    color: 'attentionSecondaryContent',
    icon: faCircleInfo
  },
  PASS: {
    backgroundColor: 'successPrimaryContentAccent',
    color: 'neutralPrimaryFill',
    icon: faCheck
  },
  BROWN: {
    backgroundColor: 'neutralSecondaryFill',
    color: 'attentionSecondaryContent',
    icon: faBug
  },
  ORANGE: {
    backgroundColor: 'attentionPrimaryContentAccent',
    color: 'attentionSecondaryContent',
    icon: faCircleInfo
  },
  PENDING: {
    backgroundColor: 'neutralSecondaryFill',
    color: 'actionSecondaryContent',
    icon: faClock
  }
};

const IntegrityStatusIcon = (props: {
  severity: EResultStatus | ECheckLifecycleStatus;
}) => {
  const { severity } = props;

  return (
    <Flex
      padding={0.5}
      gap={2.5}
      alignItems="flex-start"
      borderRadius="small"
      backgroundColor={colorsAndIcons[severity]?.backgroundColor}
      color={colorsAndIcons[severity]?.color}
    >
      <Flex
        gap={8}
        width={6}
        height={6}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <FontAwesomeIcon
          fontStyle="textContext"
          icon={colorsAndIcons[severity]?.icon}
        />
      </Flex>
    </Flex>
  );
};

export default IntegrityStatusIcon;
